import { ExtendedMap } from '../plugin/ext-map.type';

export const measurementArrays = new ExtendedMap<Array<string>>();

const measurementSystemArray = ['IMPERIAL', 'METRIC'];
measurementArrays.set('measurementSystem', measurementSystemArray);
export type MeasurementSystemUnits = (typeof measurementSystemArray)[number];

const temperatureArray = ['FAHRENHEIT', 'CELSIUS'];
measurementArrays.set('temperature', temperatureArray);
export type TemperatureUnits = (typeof temperatureArray)[number];

const distanceArray = ['FEET', 'METERS'];
measurementArrays.set('distance', distanceArray);
export type DistanceUnits = (typeof distanceArray)[number];

const volumeArray = ['FEET_CUBED', 'METERS_CUBED'];
measurementArrays.set('volume', volumeArray);
export type VolumeUnits = (typeof volumeArray)[number];

const weightArray = ['TONS', 'METRIC_TONS'];
measurementArrays.set('weight', weightArray);
export type WeightUnits = (typeof weightArray)[number];

export interface JmkwUnitConfig {
  measurementSystem: MeasurementSystemUnits;
  temperature: TemperatureUnits;
  distance: DistanceUnits;
  volume: VolumeUnits;
  weight: WeightUnits;
}

export type JmkwUnitConfigKey = keyof JmkwUnitConfig;

export const IMPERIAL_DEFAULT: JmkwUnitConfig = {
  measurementSystem: 'IMPERIAL',
  temperature: 'FAHRENHEIT',
  distance: 'FEET',
  volume: 'FEET_CUBED',
  weight: 'TONS'
};

export const METRIC_DEFAULT: JmkwUnitConfig = {
  measurementSystem: 'METRIC',
  temperature: 'CELSIUS',
  distance: 'METERS',
  volume: 'METERS_CUBED',
  weight: 'METRIC_TONS'
};

export const UNIT_CONFIG_DEFAULTS = new ExtendedMap<JmkwUnitConfig>([
  ['IMPERIAL', IMPERIAL_DEFAULT],
  ['METRIC', METRIC_DEFAULT]
]);
